/* Types */
import { BasketPayment, SavedCard } from '@/types/api/api-v3/paymentMethods'

/**
 * Проверка на то, что это сохраненная карта, у сохраненной карты нет поля [type]
 * @param payment - тип оплаты
 */
export const checkSavedCard = (
  payment: BasketPayment | null,
): payment is SavedCard => !!payment && payment.type === undefined
